import { render } from "./Role.vue?vue&type=template&id=176db0eb"
import script from "./Role.vue?vue&type=script&lang=ts"
export * from "./Role.vue?vue&type=script&lang=ts"
script.render = render

export default script